import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://newsip.thecodevo.com/api';

const getSessionId = () => {
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = 'sid_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
};

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add interceptors for all requests
api.interceptors.request.use((config) => {
    // Add session ID for view tracking
    config.headers['X-Session-Id'] = getSessionId();

    // Check if this is an admin API call
    const isAdminCall = config.url.includes('/admin') ||
        config.url.includes('/upload-image') ||
        (config.method !== 'get' && !config.url.includes('/view') && !config.url.includes('/like'));

    // For admin operations, add auth token
    if (isAdminCall) {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    return config;
});

// Handle 401 unauthorized responses
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Clear token and redirect to login for admin routes
            if (window.location.pathname.includes('/admin')) {
                localStorage.removeItem('adminToken');
                window.location.href = '/admin';
            }
        }
        return Promise.reject(error);
    }
);

export default api;